import { MapData } from "./Map.types"

export const MapInitState:MapData = {
    maps:[]
}